import React, { PropsWithChildren } from 'react';

import { Tooltip } from 'flowbite-react';

interface IProps extends PropsWithChildren {
	content: string;
	textClassName?: string;
	placement?: any;
	arrow?: boolean;
	style?: any;
	color?: any;
}

const getArrowStyle = (placement: string) => {
	switch (placement) {
		case 'top':
			// Arrow points down, so border-b is visible
			return 'bg-white border-b-2 border-primary border-b  border-r';
		case 'bottom':
			// Arrow points up, so border-t is visible
			return 'bg-white border-t-2 border-primary border-t border-l';
		case 'left':
			// Arrow points right, so border-r is visible
			return 'bg-white border-r-2 border-primary border-r border-t';
		case 'right':
			// Arrow points left, so border-l is visible
			return 'bg-white border-l-2 border-primary border-l border-b';
		default:
			return 'bg-white border-b-2 border-primary';
	}
};

const TooltipContainer: React.FC<IProps> = (props) => {
	const placement = props.placement || 'top';
	return (
		<Tooltip
			arrow={props.arrow as boolean}
			placement={placement}
			content={<p className={`text-center ${props.textClassName}`}>{props.content}</p>}
			theme={{
				target: 'w-full ',
				style: {
					auto: 'bg-white border border-primary'
				},
				arrow: {
					style: {
						auto: getArrowStyle(placement)
					}
				}
			}}
			color={props.color}
			style={props.style}
		>
			{props.children}
		</Tooltip>
	);
};

export default TooltipContainer;
